// config.ts

export const NS: string = "__earnWld__";
export const NS2: string = "__earnHub__";
export const WORKER_BASE: string = "https://faucet.ew.bridge.cm";
export const FAUCET_ADDRESS: string =
    "0xEbE4a875A8586bBbE405e0Ab1082425fa304bDb9";
export const MINI_APP_ID: string = "app_8ef6a5c8af9dce473c8a5b6b3808308f";
export const CLIENT_VERSION: string = "1.0.0";
// export const API_BASE: string =
//     import.meta.env.VITE_NODE_ENV === "development"
//         ? "https://dev-api.eh.bridge.cm"
//         : "https://api.eh.bridge.cm";
const API_BASE_OVERRIDE = import.meta.env.VITE_API_BASE_OVERRIDE;
export const API_BASE: string =
    typeof API_BASE_OVERRIDE === "string" && API_BASE_OVERRIDE.trim()
        ? API_BASE_OVERRIDE.trim()
        : import.meta.env.VITE_NODE_ENV === "development"
          ? "https://dev-api.eh.bridge.cm"
          : "https://api.eh.bridge.cm";
export const GAE_DEEPLINK_ENV: string | null = "production";
